<template>
  <div id="insurance-detail">

    <div class="fixed-nav" v-show="uiSwitch.isShowFixedNav">
      <div class="body" v-if="insuranceData.insurance_product">
        <div class="left-content">
          <div class="insurance-name">{{insuranceData.insurance_product.insurance_name}}</div>
          <div class="select-plan">
            <el-select v-model="insuranceData.restrict_genes[planIndex].default" @change="changeInsurancePlan(insuranceData.restrict_genes[planIndex].default)" placeholder="请选择">
              <el-option
                v-for="(item, index) in insuranceData.restrict_genes[planIndex].options"
                :key="index"
                :label="calculateSelectLabel(item, insuranceData.restrict_genes[planIndex].name)"
                :value="calculateSelectValue(item, insuranceData.restrict_genes[planIndex].name)"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="right-content">
          <div class="price-box">
            <span class="currency">¥</span>{{singlePrice | price}}
          </div>
          <div class="submit-btn">
            <button class="s-btn btn-orange is-round" disabled v-if="insuranceData.insurance_product.status === 0">该商品已下架</button>
            <button class="s-btn btn-orange is-round" @click="jumpToInsuranceOrder" v-display:create-insurance-order v-else>立即投保</button>
          </div>
        </div>
      </div>
    </div>

    <div class="bread">
      <router-link class="bread-item" to="/">上上签</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" :to="'/insurances'">保险商城</router-link>
      <div class="bread-arrow">&gt;</div>
      <div class="bread-item bread-ellipsis" v-if="insuranceData.insurance_product">{{insuranceData.insurance_product.insurance_name}}</div>
    </div>

    <div class="content-box">

      <div class="content-header content-item" v-if="insuranceData.insurance_product">
        <div class="header-left">
          <div class="product-cover">
            <img class="cover-img" :src="insuranceData.insurance_product.cover" alt="">
            <img class="company-logo-img" :src="insuranceData.insurance_product.company_logo" alt="">

            <div class="recommend-icon" v-if="insuranceData.insurance_product.top_status === 1"></div>
          </div>
        </div>
        <div class="header-right">
          <div class="product-title">{{insuranceData.insurance_product.insurance_name}}</div>
          <div class="price-box">
            <div class="label">保费金额</div>
            <div class="sell-price">
              <!-- <span class="currency">¥</span>{{singlePrice | price}} -->
              <span class="currency">¥</span>{{originalPrice | price}}
            </div>
            <!-- <div class="origin-price" v-if="singlePrice !== originalPrice">
              原价<span class="price">¥{{originalPrice | price}}</span>
            </div> -->
            <span class="price-tip">价格供参考，实际金额以下单为准</span>
          </div>

          <div class="plan-box">
            <div class="plan-item" v-for="(planItem, index) in insuranceData.restrict_genes" :key="index">
              <div class="plan-item-label">{{planItem.name}}</div>
              <div class="plan-item-content" v-if="planItem.name == '承保职业'">
                <div class="profession-box">
                  <div class="profession">{{planItem.default}}</div>
                  <a v-if="planItem.url" :href="planItem.url" target="_blank" class="profession-link">查询职业类别</a>
                </div>
              </div>
              <div class="plan-item-content" v-else>
                <template v-if="planItem.options.length <= 5 || planItem.name === '套餐选择'">
                  <div
                    class="option-item"
                    :class="{active: !planItem.otherValue && planItem.default === calculateSelectValue(item, planItem.name)}"
                    @click="changeInsuranceOption(planItem, item)"
                    v-for="(item, index) in planItem.options"
                    :key="index"
                  >{{calculateSelectLabel(item, planItem.name)}}</div>
                </template>
                <template v-else>
                  <div
                    class="option-item"
                    :class="{active: !planItem.otherValue && planItem.default === calculateSelectValue(item, planItem.name)}"
                    @click="changeInsuranceOption(planItem, item)"
                    v-for="(item, index) in planItem.options.slice(0, 4)"
                    :key="index"
                  >{{calculateSelectLabel(item, planItem.name)}}</div>

                  <el-select
                    class="other-option"
                    :class="{active: planItem.otherValue}"
                    v-model="planItem.otherValue"
                    @change="calculatePrice"
                    placeholder="更多选择"
                  >
                    <el-option
                      v-for="item in planItem.options.slice(4)" :key="item.value"
                      :value="calculateSelectValue(item, planItem.name)"
                      :label="calculateSelectLabel(item, planItem.name)">
                    </el-option>
                  </el-select>
                </template>

              </div>
            </div>
          </div>

          <div class="submit-btn" v-display:create-insurance-order>
            <button class="s-btn btn-orange is-round btn-lg is-plain" v-if="insuranceData.insurance_product.status !== 0" @click="shareToCustomer">分享给顾客</button>
            <el-button class="s-btn btn-orange is-round btn-lg" :disabled="insuranceData.insurance_product.status === 0" @click="jumpToInsuranceOrder">{{insuranceData.insurance_product.status === 0 ? '该商品已下架': '立即办理'}}</el-button>
          </div>

        </div>
      </div>

      <!-- 保险详情 -->
      <div class="content-detail content-item">
        <!-- 计划详情 -->
        <div class="content-project" v-if="insuranceData.restrict_genes">
          <div class="project-header">
            <div class="first-line">
              <div class="insurance-name">{{insuranceData.insurance_product.insurance_name}}</div>
            </div>
            <div class="project-line" :class="{'active': insuranceData.restrict_genes[0].default === project.case_code}" :key="index"
              v-for="(project, index) in insuranceData.restrict_genes[0].options" @click="changeInsurancePlan(project.case_code)">
              <div class="project-lien-body">
                <div class="name-box">
                  <div class="name">
                    {{project.value}}<div class="icon"></div>
                  </div>
                </div>
                <div class="price">
                  ¥{{project.lowest_price / 100}}<span>起</span>
                </div>
              </div>

            </div>
          </div>
          <div class="project-body-wrap">
            <div class="project-body" v-for="(project, index) in uiSwitch.isProjectExpend ? insuranceData.protect_items : insuranceData.protect_items.slice(0, 10)" :key="index">
              <div class="first-line">{{project}}</div>
              <div class="project-line" :class="{'active': insuranceData.restrict_genes[0].default === proj.case_code, 'is-even': index % 2 === 0}" :key="ind"
                v-for="(proj, ind) in insuranceData.restrict_genes[0].options" @click="changeInsurancePlan(proj.case_code)">
                <!-- 这数据结构返回得也是奇葩无比了 -->
                {{getDescIndex(proj.protect_items_name, project) > -1 ? (filterProjectDetailArr[ind][getDescIndex(proj.protect_items_name, project)] || '—')  : '—'}}
              </div>
            </div>
          </div>

        </div>

        <div class="content-expend" v-if="insuranceData.protect_items && insuranceData.protect_items.length > 10" :class="{'icon-reverse': uiSwitch.isProjectExpend}"
          @click="toggleUiExpend('isProjectExpend')">{{uiSwitch.isProjectExpend? '收起' : '查看全部'}}</div>
      </div>

      <!-- 投保须知 -->
      <div class="content-info content-item" v-if="filterInfoArr">
        <div class="info-subtitle">投保须知</div>
        <div class="info-content">
          <div class="info-text" v-for="(text, index) in filterInfoArr" :key="index">
            <span>{{index + 1}}.</span>
            <span v-html="text"></span>
          </div>
        </div>
        <div class="content-expend" :class="{'icon-reverse': uiSwitch.isInfoExpend}" v-if="insuranceData.tips && insuranceData.tips.length > 5"
          @click="toggleUiExpend('isInfoExpend')">{{uiSwitch.isInfoExpend? '收起': '查看全部'}}</div>
      </div>

      <!-- 理赔须知 -->
      <div class="content-process content-item">
        <div class="process-subtitle">理赔流程</div>
        <div class="process-content">
          <div class="process-item" v-for="(pro, index) in insuranceDetailProcess" :key="index">
            <div class="process-left">
              <div class="icon" :style="{backgroundImage: `url(${$importImage(pro.icon)})`}"></div>
              <div class="line" :class="{'is-long': index === 0}" v-if="insuranceDetailProcess && index < insuranceDetailProcess.length - 1"></div>
            </div>
            <div class="process-right">
              <div class="index">{{pro.index}}</div>
              <div class="bg-index" :class="[`index-${index + 1}`]" :style="{}"></div>
              <div class="body">
                <div class="title">{{pro.title}}</div>
                <div class="content">{{pro.content}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="footer-desc">本页面保险产品咨询、理赔等服务均由慧择保险提供</div>

    <!-- 分享给顾客 -->
    <share-with-friends
      v-model="shareModalShow"
      :product="insuranceData"
      :code-url="codeUrl"
    ></share-with-friends>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';

import { mapMutations } from 'vuex';
import { insuranceDetailProcess } from '../../datas/insurance-products';
import User from '../../libs/user.js';
import insuranceApi from '../../api/insurance-api';
import wxUtils from '../../libs/wx-utils';
import shareWithFriends from './components/share-with-friends';

export default {
  name: 'insuranceDetail',
  components: {
    shareWithFriends,
  },
  data() {
    return {
      insuranceDetailProcess, // 理赔流程固定数据
      User,
      id: +this.$route.params.id || 0, // 保险的商品ID
      caseCode: this.$route.query.caseCode || 0, // 当前选中的套餐
      insuranceData: {},
      originalPrice: 0,
      singlePrice: 0,
      uiSwitch: { // ui的开关标记
        isShowFixedNav: false,
        isInfoExpend: false,
        isProjectExpend: false,
      },
      shareModalShow: false,
      codeUrl: '',
    };
  },
  computed: {
    planIndex() {
      if (!this.insuranceData.restrict_genes) return 0;
      return this.insuranceData.restrict_genes.findIndex(item => item.name === '套餐选择');
    },
    // 计算保险条款链接
    calculateInsuranceHref() {
      let newHref = '';
      if (this.insuranceData.restrict_genes) {
        this.insuranceData.restrict_genes[0].options.forEach((op) => {
          if (op.case_code === this.insuranceData.restrict_genes[0].default) {
            newHref = op.clause;
          }
        });
      }
      return newHref;
    },
    // 过滤投保须知数组
    filterInfoArr() {
      if (this.insuranceData.tips) {
        return this.insuranceData.tips.filter((info, index) => {
          if (!this.uiSwitch.isInfoExpend) {
            return index < 5;
          }
          return true;
        });
      }
      return undefined;
    },
    // 抽取保险计划的保障金额数组
    filterProjectDetailArr() {
      const newArr = [];
      if (this.insuranceData.restrict_genes) {
        this.insuranceData.restrict_genes.forEach((item) => {
          if (item.options) {
            item.options.forEach((option) => {
              if (option.claim) {
                newArr.push(option.claim);
              }
            });
          }
        });
      }
      return newArr;
    },
  },
  created() {
    this.getInsuranceDetail();
  },
  mounted() {
    window.addEventListener('scroll', this.scrollEventFun);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollEventFun);
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),

    getInsuranceDetail() {
      const loadingIns = this.$loading();
      insuranceApi.insuranceDetails({ id: this.id, case_code: this.caseCode || undefined }).then((data) => {
        this.insuranceData = this.flatProtect(data);
        this.caseCode = this.insuranceData.restrict_genes[0].default;
        this.calculatePrice();
        loadingIns.close();
      }).catch((e) => {
        if (e) console.log(e);
        loadingIns.close();
      });
    },
    // 往url里面添加参数
    addUrlQuery(key, value) {
      const query = JSON.parse(JSON.stringify(this.$route.query)) || {};
      query[key] = value;
      this.$router.replace({ query });
    },
    // 切换选项
    changeInsuranceOption(planItem, optionItem) {
      if (planItem.name === '套餐选择') {
        this.changeInsurancePlan(optionItem.case_code);
        return;
      }
      planItem.default = this.calculateSelectValue(optionItem, planItem.name);
      planItem.otherValue = '';
      this.calculatePrice();
    },
    changeInsurancePlan(caseCode) {
      if (this.caseCode === caseCode) return;
      this.caseCode = caseCode;
      this.getInsuranceDetail();
    },
    toggleUiExpend(switchBar) {
      this.uiSwitch[switchBar] = !this.uiSwitch[switchBar];
    },
    jumpToInsuranceOrder() {
      if (!User.isLogin()) {
        MtaH5.clickStat('login', { insurance: 'true' });
        this.SHOW_LOGIN_BOX({ from: 'buy_insurance' });
      } else {
        MtaH5.clickStat('insuranceorder0start');
        // 保险预提交
        insuranceApi.insurancePreSubmit(this.buildPreSubmitQuery()).then((data) => {
          sensorsdata.track('Insuring_now', {
            peer_name: User.peer.peer_name,
            visa_peer_id: User.peer.visa_peer_id,
          });
          this.$router.push({ name: 'insuranceInfo',
            query: {
              insuranceId: data.insurance_id,
            } });
        }).catch((e) => {
          if (e) console.log(e);
        });
      }
    },
    getDescIndex(descs, srcDesc) {
      const index = descs.findIndex(desc => desc === srcDesc);
      return index;
    },
    buildPreSubmitQuery() {
      const params = {};
      this.insuranceData.restrict_genes.forEach((item) => {
        const value = item.otherValue || item.default;
        if (item.name === '套餐选择') {
          params.case_code = value;
          params.plan_name = item.options.filter(op => op.case_code && op.case_code === value)[0].value;
        } else if (item.name === '承保年龄') {
          params.insurant_age = value;
        } else if (item.name === '旅行延误升级') {
          if (value === '是') {
            params.travel_delays = 1;
          } else {
            params.travel_delays = 0;
          }
        } else if (item.name === '保障期限') {
          params.protect_days = value;
        }
      });
      params.product_name = this.insuranceData.insurance_product.insurance_name;
      params.single_price = this.singlePrice;
      params.original_price = this.originalPrice;
      params.for_who = 0;
      return params;
    },
    // 计算选项的值
    calculateSelectValue(item, name) {
      if (name === '套餐选择') {
        return item.case_code;
      } else if (name === '承保年龄') {
        return item.value + item.unit;
      } else if (name === '旅行延误升级') {
        return item.name;
      } else if (name === '保障期限') {
        return item.value + item.unit;
      }
    },
    // 计算标签的值
    calculateSelectLabel(item, name) {
      if (name === '套餐选择') {
        return item.value;
      } else if (name === '承保年龄') {
        return item.value + item.unit;
      } else if (name === '旅行延误升级') {
        return item.name;
      } else if (name === '保障期限') {
        return item.value + item.unit;
      }
    },
    // 根据选项计算保险金额
    calculatePrice() {
      const params = {};
      this.insuranceData.restrict_genes.forEach((item) => {
        // 如果有选择其他有值，则使用otherValue，否则使用default
        const value = item.otherValue || item.default;
        if (item.name === '套餐选择') {
          params.case_code = value;
        } else if (item.name === '承保年龄') {
          params.insurant_age = value;
        } else if (item.name === '旅行延误升级') {
          if (value === '是') {
            params.travel_delays = 1;
          } else {
            params.travel_delays = 0;
          }
        } else if (item.name === '保障期限') {
          if (value === '1年') {
            params.protect_days = '365天';
          } else if (value.indexOf('1年') > -1 && value.length > 2) {
            params.protect_days = '365天';
            params.extended = value;
          } else {
            params.protect_days = value;
          }
        }
      });
      insuranceApi.insuranceSimpleTrial(params).then((data) => {
        this.singlePrice = data.single_price;
        this.originalPrice = data.original_price;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    // 展开保障期限中的区间选项
    flatProtect(insuranceData) {
      insuranceData.restrict_genes.forEach((item) => {
        item.otherValue = '';
        if (item.name === '保障期限') {
          const newOptions = [];
          item.options.forEach((op) => {
            // 若type等于2，表明是区间
            if (+op.type === 1) {
              newOptions.push(op);
            } else {
              let startNum = op.min;
              while (startNum <= op.max) {
                newOptions.push({
                  value: startNum,
                  step: 0,
                  unit: op.unit,
                  max: startNum,
                  min: startNum,
                  type: '1',
                });
                startNum += op.step;
              }

              if (startNum < op.max + op.step) {
                newOptions.push({
                  value: op.max,
                  step: 0,
                  unit: op.unit,
                  max: op.max,
                  min: op.max,
                  type: '1',
                });
              }
            }
          });
          item.options = newOptions;
        }
      });
      return insuranceData;
    },
    // 滚动事件
    scrollEventFun() {
      const contentDetailTop = document.querySelector('.content-detail') ? document.querySelector('.content-detail').getBoundingClientRect().top : 0;
      if (contentDetailTop - 68 > 0) {
        this.uiSwitch.isShowFixedNav = false;
      } else {
        this.uiSwitch.isShowFixedNav = true;
      }
    },
    // 分享给顾客
    shareToCustomer() {

      // 未登录跳转到登录
      if (!User.isLogin()) {
        this.SHOW_LOGIN_BOX({ from: 'insurance_detail_share' });
        return;
      }

      // 未绑定跳转到绑定
      if ((!User.wxinfo || !User.wxinfo.openid) && !User.is_palmyou) {
        return this.$router.push({ name: 'bind', query: { redirectUrl: encodeURIComponent(this.$route.fullPath) } });
      }

      wxUtils.getInsuranceDetailWxaCode(this.id).then(
        (data) => {
          this.codeUrl = data;
          this.shareModalShow = true;
        },
        () => {
        },
      ).catch((e) => {
        if (e) console.log(e);
      });
    },
  },

};
</script>

<style lang="less" scoped>
@import "../../assets/less/variable";

#insurance-detail {
  width: 1120px;
  margin: 0 auto 60px;

  .fixed-nav{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    width: 100%;
    z-index: 2001;
    height: 68px;
    background: #fff;
    box-shadow:0px 4px 8px 0px rgba(47,51,61,0.08);
    .body{
      width: 1120px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 1;
      .left-content{
        display: flex;
        align-items: center;
        .insurance-name{
          color: #2F333D;
          font-size: 24px;
          font-weight: 600;
          margin-right: 12px;
        }
        .select-plan{
          /deep/ .el-select{
            height: 32px;
            width: 150px;
            .el-input{
              .el-input__icon{
                width: 24px;
                transform: translateY(-50%) rotateZ(180deg) scale(0.7);
                transform-origin: center center;
                right: 4px;
                color: #91999F;
                &.is-reverse{
                  transform: translateY(-50%) scale(0.7);
                }
              }
              .el-input__inner{
                width: 100%;
                height: 32px;
                border-radius: 2px;
                padding-right: 24px;
              }
            }
          }
        }
      }
      .right-content{
        display: flex;
        align-items: center;
        .price-box{
          display: flex;
          align-items: baseline;
          color: #FF8033;
          font-weight: 600;
          font-size: 32px;
          .currency{
            font-size: 20px;
          }   
        }
      }
      .submit-btn{
        margin-left: 16px;
        .s-btn{
          box-shadow:0px 12px 20px -8px rgba(255,128,51,0.5);
          width: 136px;
          height: 40px;
          border-radius: 20px;
          &:disabled{
            box-shadow: none;
          }
        }
      }
    }
  }

  .bread {
    display: flex;
    align-items: center;
    .bread-ellipsis {
      width: 160px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .custom-serivce {
    padding-left: 20px;
    display: flex;
    align-items: center;
    font-size: 14px;
    height: 36px;
    background-color: #fffac4;
    color: #6f6f6f;
    font-size: 12px;
  }
  .content-box {
    width: 1120px;
    position: relative;
    .content-item {
      background-color: #fff;
      border-radius:2px;
      box-shadow:0px 2px 4px 0px rgba(0,0,0,0.06);
      margin-bottom: 16px;
    }
    .content-header{
      padding: 24px 32px 0 24px;
      display: flex;
      .header-left{
        width: 400px;
        flex-shrink: 0;
        .product-cover{
          position: relative;
          .cover-img{
            width: 100%;
            height: 240px;
          }
          .company-logo-img{
            margin-top: 16px;
            height: 45px;
          }
          .recommend-icon{
            width: 62px;
            height: 69px;
            position: absolute;
            right: 0;
            top: -4px;
            z-index: 1;
            background: url(../../assets/imgs/insurance-new/icon-recommend.png) no-repeat center /  100% 100%;
          }
        }
      }
      .header-right{
        flex-grow: 1;
        overflow: hidden;
        padding-top: 6px;
        padding-bottom: 24px;
        margin-left: 24px;
        .product-title{
          color: #444444;
          font-size: 28px;
          line-height: 40px;
          margin-bottom: 18px;
          font-weight: 600;
        }
        .price-box{
          background:linear-gradient(270deg,rgba(255,128,51,0) 0%,rgba(255,128,51,0.08) 100%);
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          // height: 62px;
          line-height: 1;
          padding: 16px 0;
          padding-left: 8px;
          .label{
            font-size: 14px;
            color: #2F333D;
            margin-right: 16px;
          }
          .sell-price{
            color: #FF8033;
            font-size: 28px;
            font-weight: 600;
            letter-spacing: 0;
            margin-top: -4px;
            .currency{
              font-size: 18px;
            }
          }
          .origin-price{
            margin-left: 12px;
            color: #91999F;
            font-size: 14px;
            .price{
              text-decoration: line-through;
            }
          }
          .price-tip {
            flex-basis: 100%;
            display: block;
            font-size: 12px;
            color: @text-aaa;
            padding-top: 8px;
          }
        }
        .plan-box{
          margin-top: 16px;
          .plan-item{
            display: flex;
            align-items: flex-start;
            margin-bottom: 16px;
            &:last-child{
              margin-bottom: 0;
            }
            .plan-item-label{
              flex-shrink: 0;
              min-height: 38px;
              display: flex;
              align-items: center;
              color: #2F333D;
              font-size: 14px;
              line-height: 18px;
              margin-right: 16px;
              width: 60px;
            }
            .plan-item-content{
              flex-grow: 1;
              overflow: hidden;
              display: flex;
              flex-wrap: wrap;
              margin-right: -16px;
              margin-bottom: -8px;
              .option-item{
                padding: 0 24px;
                height: 38px;
                line-height: 38px;
                color: #5F666E;
                font-size: 14px;
                border-radius:2px;
                margin-right: 16px;
                margin-bottom: 8px;
                position: relative;
                cursor: pointer;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                &::before{
                  content: "";
                  position: absolute;
                  left: 0;
                  right: 0;
                  width: 100%;
                  height: 100%;
                  z-index: 1;
                  border: 1px solid #DEE2E6;
                  border-radius:2px;
                  box-sizing: border-box;
                }
                &.active{
                  color: #2F333D;
                  font-weight: 600;
                  &::before{
                    border: 2px solid #599FFF;
                  }
                  &::after{
                    content: "";
                    width: 24px;
                    height: 24px;
                    background: url(../../assets/imgs/insurance-new/icon-select.png) no-repeat center / 100% 100% ;
                    position: absolute;
                    z-index: 2;
                    right: 0;
                    bottom: 0;
                  }
                }
              }
              .other-option{
                width: 100px;
                height: 38px;
                &.active{

                  position: relative;
                  &::after{
                    content: "";
                    width: 24px;
                    height: 24px;
                    background: url(../../assets/imgs/insurance-new/icon-select.png) no-repeat center / 100% 100% ;
                    position: absolute;
                    z-index: 2;
                    right: 0;
                    bottom: 0;
                  }
                  /deep/ .el-input{
                    .el-input__inner{
                      border: 2px solid #599FFF;
                      color: #2F333D;
                      font-weight: 600;
                    }
                  }
                }
                /deep/ .el-input{
                  .el-input__icon{
                    width: 24px;
                    color: #91999F;
                    transform: translateY(-50%) rotateZ(180deg) scale(0.7);
                    transform-origin: center center;
                    right: 4px;
                    &.is-reverse{
                      transform: translateY(-50%) scale(0.7);
                    }
                  }
                  .el-input__inner{
                    height: 38px;
                    border-radius: 2px;
                    padding-right: 24px;
                    color: #5F666E;
                    &::placeholder{
                      color: #5F666E;
                    }
                  }
                }
              }

              .profession-box{
                display: flex;
                align-items: center;
                min-height: 38px;
                .profession{
                  color: #2F333D;
                  font-size: 14px;
                  font-weight: 600;
                }
                .profession-link{
                  margin-left: 12px;
                  font-size: 14px;
                  color: #599FFF;
                }
              }
            }
          }
        }
        .submit-btn{
          margin-top: 24px;
          padding-bottom: 16px;
          .s-btn{
            box-shadow:0px 12px 20px -8px rgba(255,128,51,0.5);
            width: 146px;
            &:disabled{
              box-shadow: none;
            }
          }
          .s-btn.is-plain{
            box-shadow: none;
            margin-right: 10px;
          }
        }
      }
    }
    .content-detail {
      padding: 16px 40px 32px 24px;
      .content-project {
        margin-bottom: 32px;
        font-size: 14px;
        .project-header{
          display: flex;
          .first-line{
            width: 396px;
            color: #2F333D;
            font-size: 24px;
            font-weight: 600;
            line-height: 40px;
            padding: 20px 0;
            position: relative;
            .insurance-name{
              width: 280px;
              position: relative;
              z-index: 1;
              &::after{
                content: "";
                width:82px;
                height:7px;
                background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,1) 100%);
                opacity:0.6;
                position: absolute;
                left: 0;
                top: 27px;
                z-index: -1;
              }
            }
          }
          .project-line{
            flex: 1;
            padding: 16px 0 24px 0;
            line-height: 1;
            display: flex;
            flex-direction: column;
            border-left: 1px solid #fff;
            position: relative;
            cursor: pointer;
            .project-lien-body{
              flex-grow: 1;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              padding: 4px;
              background: #F3F6F9;
              border-radius:8px 8px 0 0;
              padding: 18px 12px 16px 12px;
              .name-box{
                text-align: center;
                .name{
                  color: #2F333D;
                  font-size: 20px;
                  line-height: 28px;
                  font-weight: 600;
                }
                .icon{
                  vertical-align: top;
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  flex-shrink: 0;
                  width: 14px;
                  height: 14px;
                  background:linear-gradient(270deg,rgba(201,205,209,1) 0%,rgba(145,153,159,1) 100%);
                  opacity:0.8;
                  margin-top: 7px;
                  border-radius: 50%;
                  margin-left: 4px;
                  &::after{
                    content: "";
                    width: 6px;
                    height: 5px;
                    background: url(../../assets/imgs/insurance-new/plan-down-white.png) no-repeat center / 100% 100%;
                  }
                }
              }

              .price{
                margin-top: 12px;
                color: #91999F;
                font-size: 18px;
                display: flex;
                align-items: baseline;
                span{
                  font-size: 12px;
                  margin-left: 2px;
                }
              }

            }
            &.active{
              padding-top: 0;
              &::before{
                content: "";
                position: absolute;
                left: 0;
                height: 30px;
                bottom: -1px;
                width: 2px;
                background: #599FFF;
              }
              &::after{
                content: "";
                position: absolute;
                right: 0;
                height: 30px;
                bottom: -1px;
                width: 2px;
                background: #599FFF;
              }
              .project-lien-body{
                background:linear-gradient(360deg,rgba(89,159,255,1) 0%,rgba(64,131,255,1) 100%);
                box-shadow:0px 8px 20px -6px rgba(89,159,255,0.4);
                color: #fff;
                .name-box{
                  .name{
                    color: #fff;
                    font-size: 24px;
                    line-height: 28px;
                  }
                  .icon{
                    width: 16px;
                    height: 16px;
                    background:#fff;
                    margin-top: 6px;
                    &::after{
                      content: "";
                      width: 10px;
                      height: 7px;
                      background: url(../../assets/imgs/insurance-new/plan-down-blue.png) no-repeat center / 100% 100%;
                    }
                  }
                }
                .price{
                  margin-top: 16px;
                  color: #fff;
                  font-size: 20px;
                  font-weight: 600;
                  span{
                    font-weight: normal;
                    font-size: 16px;
                  }
                }
              }
            }


          }
        }
        .project-body{
          display: flex;
          &:nth-child(odd){
            .first-line{
              background: #FAFBFC;
            }
          }
          .first-line{
            flex-shrink: 0;
            width: 396px;
            padding: 12px 16px;
            color: #2F333D;
            font-size: 16px;
            line-height: 24px;
            border-bottom: 1px solid #E9EEF2;
          }
          .project-line{
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 12px 16px;
            color: #2F333D;
            font-size: 18px;
            font-weight: 600;
            border-left: 1px solid #fff;
            border-bottom: 1px solid #E9EEF2;
            position: relative;
            cursor: pointer;
            &.is-even{
              background: #FAFBFC;
            }
            &.active{
              &::before{
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                bottom: -1px;
                width: 2px;
                background: #599FFF;
              }
              &::after{
                content: "";
                position: absolute;
                top: 0;
                right: 0;
                bottom: -1px;
                width: 2px;
                background: #599FFF;
              }
              &.is-even{
                background:rgba(89,159,255,0.08);
                border-bottom: 1px solid rgba(89,159,255,0.16);
              }
            }
          }
          &:last-child{
            .project-line{
              &.active{
                border-radius: 0 0 8px 8px;
                &::before{
                  display: none;
                }
                &::after{
                  border-radius: 0 0 8px 8px;
                  width: 100%;
                  left: 0;
                  border: 2px solid #599FFF;
                  border-top: none;
                  background: none;
                  box-sizing: border-box;
                }
              }
            }
          }

        }
      }
    }

    .content-info {
      padding: 24px 24px 32px 24px;
      .info-subtitle {
        font-size: 24px;
        font-weight: 600;
        line-height: 1;
        color: #2F333D;
        position: relative;
        z-index: 1;
        margin-bottom: 24px;
        &::before {
          content: '';
          position: absolute;
          bottom: 0px;
          left: 0px;
          width:82px;
          height:7px;
          background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,0.6) 100%);
          z-index: -1;
        }
      }
      .info-content {
        margin-bottom: 32px;
        .info-text {
          font-size: 16px;
          line-height: 36px;
          color:#2F333D;
          span {
            strong {
              color: red;
              font-weight: normal;
            }
            a {
              color: @blue;
            }
          }
        }
      }
    }

    .content-process {
      padding: 24px 24px 32px 24px;
      .process-subtitle {
        font-size: 24px;
        font-weight: 600;
        line-height: 1;
        color: #2F333D;
        position: relative;
        z-index: 1;
        margin-bottom: 40px;
        &::before {
          content: '';
          position: absolute;
          bottom: 0px;
          left: 0px;
          width:82px;
          height:7px;
          background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,0.6) 100%);
          z-index: -1;
        }
      }
      .process-content {
        .process-item {
          display: flex;
          margin-bottom: 28px;
          .process-left {
            width: 70px;
            flex-shrink: 0;
            position: relative;
            z-index: 3;
            .icon{
              position: absolute;
              left: -12px;
              top: 0;
              width: 100px;
              height: 104px;
              background-size: 100% 100%;
            }
            .line{
              position: absolute;
              left: 30px;
              top: 86px;
              width: 16px;
              height: 74px;
              background: url(../../assets/imgs/insurance-new/process-line.png) no-repeat center / 100% 100%;
              &.is-long{
                height: 100px;
                background: url(../../assets/imgs/insurance-new/process-line-long.png) no-repeat center / 100% 100%;
              }
            }
          }
          .process-right {
            padding: 24px;
            width: 815px;
            position: relative;
            border-radius:0px 8px 8px 40px;
            background:linear-gradient(270deg,rgba(251,252,255,1) 0%,rgba(244,249,255,1) 100%);
            display: flex;
            .index{
              flex-shrink: 0;
              color: #599FFF;
              font-size: 26px;
              font-weight: 600;
              margin-right: 4px;
            }
            .bg-index{
              width: 122px;
              height: 102px;
              position: absolute;
              right: 30px;
              bottom: 0;
              z-index: 1;
              &.index-1{
                background: url(../../assets/imgs/insurance-new/step-1.png) no-repeat center / 100% 100%;
              }
              &.index-2{
                background: url(../../assets/imgs/insurance-new/step-2.png) no-repeat center / 100% 100%;
              }
              &.index-3{
                background: url(../../assets/imgs/insurance-new/step-3.png) no-repeat center / 100% 100%;
              }
              &.index-4{
                background: url(../../assets/imgs/insurance-new/step-4.png) no-repeat center / 100% 100%;
              }
            }
            .body{
              width: 680px;
              position: relative;
              z-index: 2;
              .title{
                color: #2F333D;
                font-size: 20px;
                line-height: 28px;
                margin-bottom: 6px;
                font-weight: 600;
              }
              .content{
                white-space: pre-line;
                color: #2F333D;
                font-size: 16px;
                line-height: 28px;
              }
            }
          }
        }
      }
    }

    .project-box {
      position: absolute;
      width: 220px;
      padding: 30px 20px;
      background-color: #eaf3ff;
      top: 0;
      right: -220px;
      transition: transform 200ms linear;
      .select-box {
        margin-bottom: 30px;
        .title {
          margin-bottom: 10px;
          color: @text-aaa;
          font-size: 14px;
        }
      }
      .price {
        margin-bottom: 30px;
        text-align: right;
        .sell-price {
          font-size: 14px;
          color: @text-444;
          margin-bottom: 10px;
          span {
            color: @orange;
            span {
              font-weight: bold;
              font-size: 24px;
            }
          }
        }
        .origin-price {
          font-size: 13px;
          color: @text-aaa;
        }
      }
      .button {
        width: 180px;
        height: 40px;
        background-color: @blue;
        color: @white;
        margin-bottom: 14px;
        line-height: 40px;
        text-align: center;
        border-radius: 4px;
        cursor: pointer;
      }
      .protocol {
        font-size: 12px;
        text-align: center;
        a {
          color: @blue;
        }
      }
    }
  }

  .footer-desc{
    color: #91999F;
    font-size: 14px;
    text-align: center;
    margin-top: 20px;
    letter-spacing:2px;
  }

  .peer-to-wxa {
    position: fixed;
    bottom: 16px;
    // 让浮窗位置固定在离主体内容区右侧外面 20px 的位置
    // 主体内容区宽度 1000px，浮窗宽度 140px，浮窗距离左侧主体内容区 20px
    right: calc(~'(100% - 1120px) / 2 - 160px');
    z-index: 10;
  }


  // 公用样式
  .content-expend {
    margin: 0 auto;
    width: 128px;
    height: 36px;
    border-radius:24px;
    border:1px solid rgba(89,159,255,1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #599FFF;
    font-size: 16px;
    line-height: 1;
    cursor: pointer;
    padding-left: 7px;
    &::after{
      content: "";
      margin-left: 2px;
      width: 16px;
      height: 16px;
      background: url(../../assets/imgs/insurance-new/icon-down.png) no-repeat center / 100% 100%;
    }

    &.icon-reverse {
      &::after {
        transform: rotate(-180deg);
      }
    }
  }

}
</style>
<style lang="less">
@import "../../assets/less/variable";
.insurance-desc-popper {
  box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 6px 0px;
  border: 0 !important;
  .attention-content {
    max-width: 400px;
    div {
      margin-bottom: 5px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .popper__arrow {
    border-bottom-color: rgba(0, 0, 0, 0.15) !important;
  }
}
#insurance-detail {
  .select {
    color: blue;
    .el-input {
      color: red;
      input {
        border-color: @blue;
        color: @text-dark;
        width: 180px;
        height: 40px;
        font-size: 16px;
      }
      i {
        color: @blue;
      }
    }
  }
  .info-text {
    span {
      strong, a {
        font-weight: normal;
      }
      a {
        text-decoration: underline;
        color: @blue !important;
        strong>span {
          color: @blue !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/insurance/InsuranceDetail.vue